import React from 'react';
import classNames from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Container, history } from '../../../../../symphony';
import { SlStaticPagesActionTypes, StaticPagesActionsService } from '../../../../private/services/static-pages/sl-static-pages-actions.service';
import { StaticPagesContext } from '../../../../private/contexts';

import s from './CtaToWelcome.scss';

export interface ICtaToWelcome {
	id: string;
	label?: string;
	secondary?: boolean;
	onlyDesktop?: boolean;
}
export function CtaToWelcome({
	id,
	label = 'Start first lesson',
	secondary = false,
	onlyDesktop = false,
}: ICtaToWelcome) {
	useStyles(s);

	const onClick = (): void => {
		const { actions$ } = Container.take(
			StaticPagesContext,
			StaticPagesActionsService,
		);

		actions$.next({
			type: SlStaticPagesActionTypes.TrackAILandingPageClick,
			requestType: 'parallel',
			data: {
				trackParams: {
					sectionTitle: id,
					buttonId: id,
					buttonLabel: label,
					clickType: 'CTA',
				},
			},
		});

		history.push('/learn/courses/genai-in-practice');
	};

	return (
		<button
			type="button"
			onClick={onClick}
			className={classNames('cta-to-welcome', { secondary, onlyDesktop })}
		>
			{label}
		</button>
	);
}
